var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-field',{attrs:{"name":_vm.field.name}},[_c('black-packages',_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'black-packages',_vm.field.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }